import { Fragment } from 'react';

import { getLink } from 'constants/helpCenter';
import { trimName } from '../../../../utils';

const ArticleSearchPreview = ({
  collectionName,
  categoryName,
  name,
  preview,
  collectionSlug,
  slug,
  categoryFirstArticle,
  onArticleClick,
}) => {
  const url = getLink(collectionSlug, slug);

  return (
    <Fragment>
      <div className="breadcrumbs section__breadcrumbs _mb-4">
        <span className="breadcrumbs__item section__breadcrumbs-item">
          <a
            className="breadcrumbs__link section__breadcrumbs-link"
            href={getLink(collectionSlug, '')}
          >
            {trimName(collectionName)}
          </a>
        </span>
        <span className="breadcrumbs__item section__breadcrumbs-item">
          <a
            className="breadcrumbs__link section__breadcrumbs-link"
            href={getLink(collectionSlug, categoryFirstArticle)}
          >
            {categoryName}
          </a>
        </span>
      </div>
      <a href={url} onClick={onArticleClick}>
        <h2 className="title section__result-title _mb-9 _mb-note-7">{name}</h2>
        <p className="text text_size_s section__result-text _mb-16 _mb-note-12">
          {preview}...
        </p>
      </a>
    </Fragment>
  );
};

export default ArticleSearchPreview;
